module.exports = __webpack_public_path__ + "img/section-3-content_1_t_icon5.4d44ff44.png";